import React from 'react';
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'outline' | 'quiet';
  fullWidth?: boolean;
};
const base = 'inline-flex items-center justify-center gap-2 rounded-md px-7 py-3.5 text-[15px] font-medium tracking-[0.01em] transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-cream disabled:cursor-not-allowed disabled:opacity-55';
const variants = {
  primary: 'bg-teal text-cream-light hover:bg-teal-mid',
  outline: 'border border-harbor/45 bg-transparent text-harbor hover:bg-harbor-pale',
  quiet: 'border border-border bg-transparent text-ink-light hover:border-ink-light'
} as const;
export function Button({
  variant = 'primary',
  fullWidth,
  className = '',
  ...props
}: ButtonProps) {
  return <button type="button" className={`${base} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-12" data-mp="30sjr64d90poe" />;
}
type LinkButtonProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  variant?: 'primary' | 'outline' | 'quiet';
  fullWidth?: boolean;
};
export function LinkButton({
  variant = 'primary',
  fullWidth,
  className = '',
  ...props
}: LinkButtonProps) {
  return <a className={`${base} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-13" data-mp="8aqmsq8mg3hn" />;
}